import { render, staticRenderFns } from "./CardsStageSelect.vue?vue&type=template&id=4020e1a4&scoped=true"
import script from "./CardsStageSelect.vue?vue&type=script&lang=js"
export * from "./CardsStageSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4020e1a4",
  null
  
)

export default component.exports